import {ICompanySyncstep} from "../../../../../index";
import {ErrorManager} from "../../../../../error/ErrorManager";
import {MutableSyncstepFilters} from "./MutableSyncstepFilters";
import {INPUT_DATE_FORMAT} from "../../../../../constants";
import {MutableCompanySyncStep} from "../MutableCompanySyncStep";
import {nsDate} from "@component/sync/status-v2/nsDate";
import editHtml from './edit.html?raw';

export const template = editHtml;

interface IParams {
    companysyncstep: ICompanySyncstep,
    mutableCompanySyncstep: MutableCompanySyncStep
    errorManager: ErrorManager
}

export class viewModel {
    private companysyncstep: ICompanySyncstep;
    private mutableSyncstepFilters: MutableSyncstepFilters;
    private errorManager: ErrorManager;
    private minDate: string = nsDate.getMinDate().format(INPUT_DATE_FORMAT)
    private maxDate: string = nsDate.getMaxDate().format(INPUT_DATE_FORMAT)

    constructor(private params: IParams) {
        this.companysyncstep = params.companysyncstep
        this.mutableSyncstepFilters = params.mutableCompanySyncstep.mutableSyncstepFilters
        this.errorManager = params.errorManager
    }

}
